import React, { useEffect, useState } from 'react';

import Button from 'components/Button';
import { ENUM_TYPE_ACTION } from 'constants/enum';
import { TEXT_APP_SCREEN_PREVIEW } from 'constants/string/texts';
import Question from 'pages/Survey/Form/Question';

const AppScreenReview = (props) => {
  const { form, isTemplate = false } = props;
  const [currentSection, setCurrentSection] = useState(0);

  const getItemsNotDelete = (list_item) => {
    return list_item?.filter((item) => item.action !== ENUM_TYPE_ACTION.DELETE);
  };

  useEffect(() => {
    if (currentSection > getItemsNotDelete(form?.values?.sections)?.length - 1 && getItemsNotDelete(form?.values?.sections)?.length > 0) {
      setCurrentSection(getItemsNotDelete(form?.values?.sections)?.length - 1);
    }
  }, [form]);

  return (
    <div id="app-screen-review" className="w-app-screen-review h-app-screen-review">
      <h4 className="font-bold text-2xl text-black-102 text-center mb-4">{TEXT_APP_SCREEN_PREVIEW.APP_SCREEN_PREVIEW}</h4>

      <div className="relative">
        <img src={require('assets/app/iPhone.png')} alt="iphone" width={498} height={884} />
        <div className="absolute w-97.75 h-194 top-25 left-1/2 -translate-x-1/2 overflow-auto overflow-x-hidden scrollbar-hidden flex content-between flex-wrap">
          <div className="mx-auto w-91">
            <div className="px-0.5 text-center pb-6">
              <p className="text-xl font-bold break-words text-center">
                <img className="float-left mt-1" src={require('assets/resources/Arrow-iPhone.svg').default} alt="iphone" width={24} height={24} />
                {getItemsNotDelete(form?.values?.sections)?.[currentSection]?.title ||
                  `${TEXT_APP_SCREEN_PREVIEW.QUESTION_SECTION}${currentSection + 1}`}
              </p>{' '}
            </div>

            {getItemsNotDelete(form?.values?.sections)?.[currentSection]?.description && (
              <div className="pb-6 px-0.5">
                <span className="text-sm font-normal break-words text-center">
                  {getItemsNotDelete(form?.values?.sections)?.[currentSection]?.description}
                </span>
              </div>
            )}

            <div className="w-full">
              {getItemsNotDelete(getItemsNotDelete(form?.values?.sections)?.[currentSection]?.questions)?.map(
                (item) =>
                  item.title && (
                    <div className="mb-6 mx-auto w-89.5" key={`app-screen-review-${item.id}`}>
                      <Question isPreview={true} isEditQuestion={false} data={item} isTemplate={isTemplate} />
                    </div>
                  )
              )}
            </div>
          </div>
          <div className="w-full mb-6 mx-auto flex justify-between items-center flex-wrap gap-6">
            {getItemsNotDelete(form?.values?.sections)?.length - 1 === currentSection && (
              <Button color="secondary" className="text-white w-80 h-12 !rounded-full mx-auto">
                {TEXT_APP_SCREEN_PREVIEW.SUBMIT}
              </Button>
            )}

            {getItemsNotDelete(form?.values?.sections)?.length > 1 && (
              <>
                {getItemsNotDelete(form?.values?.sections)?.length > 1 && currentSection > 0 && (
                  <Button
                    color="secondary"
                    className="text-white w-80 h-12 !rounded-full mx-auto"
                    onClick={() => setCurrentSection((prevState) => prevState - 1)}
                  >
                    {TEXT_APP_SCREEN_PREVIEW.BACK}
                  </Button>
                )}
                {getItemsNotDelete(form?.values?.sections)?.length > 1 && currentSection < getItemsNotDelete(form?.values?.sections)?.length - 1 && (
                  <Button
                    color="secondary"
                    className="text-white w-80 h-12 !rounded-full mx-auto"
                    onClick={() => setCurrentSection((prevState) => prevState + 1)}
                  >
                    {TEXT_APP_SCREEN_PREVIEW.NEXT}
                  </Button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(AppScreenReview);
